import {
  CheckboxSpecs,
  CheckboxValues,
  DELETED,
  FilterMenus,
  FilterOperators,
  FilterTypes,
  getOperatorName,
  OperationValues,
  ReviewStatusValues,
} from './FilterSpecs'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'components/tooltip/Tooltip'

const CheckedName = ({ domain, type, values = [] }) => {
  const { bizChannels, trackerRight } = useSelector(
    state => state.dashboard.filter
  )
  const items = useMemo(() => {
    if (type === 'bizChannels') {
      return bizChannels
    } else if (type === 'trackers') {
      return trackerRight
    } else if (type === 'reviewStatus') {
      return ReviewStatusValues[domain]
    } else if (type === 'operation') {
      return OperationValues[domain]
    } else {
      return CheckboxValues[type]
    }
  }, [type, domain, bizChannels, trackerRight])
  const deletedChecked = values.length === 1 && values[0] === DELETED.id
  if (deletedChecked) {
    return DELETED.name
  }
  const allChecked =
    type !== 'bizChannels' &&
    type !== 'trackers' &&
    values.length > 0 &&
    !deletedChecked &&
    values.length === items.length
  if (allChecked) {
    return '전체'
  }
  return values
    .map(value => items.find(({ id }) => id === value)?.name)
    .filter(Boolean)
    .join(',')
}

const FilterText = ({ domain, type, data }) => {
  const { filterType } = FilterMenus[domain].subs.find(sub => sub.key === type)
  return (
    <>
      {filterType === FilterTypes.CHECKBOX ? (
        <CheckedName type={type} domain={domain} values={data.values} />
      ) : filterType === FilterTypes.MULTI ? (
        <>
          {data.value && (
            <>
              {Number(data.value).toLocaleString('ko-KR', {
                maximumFractionDigits: 11,
              })}
              {data.operator &&
                ` ${getOperatorName(
                  FilterOperators[data.operator],
                  filterType
                )}`}
            </>
          )}
          {data.checked && (
            <>
              {data.value && ','}
              {CheckboxSpecs[type].text}
            </>
          )}
        </>
      ) : (
        <>
          {filterType === FilterTypes.NUMBER
            ? Number(data.value).toLocaleString('ko-KR', {
                maximumFractionDigits: 11,
              })
            : data.value}
          {data.value !== '' && data.operator
            ? ` ${getOperatorName(FilterOperators[data.operator], filterType)}`
            : ''}
        </>
      )}
    </>
  )
}
FilterText.propTypes = {
  domain: PropTypes.string,
  type: PropTypes.string,
  data: PropTypes.object,
}

const FilterName = ({ domain, type, data, tooltip = false }) => {
  const domainName = FilterMenus[domain].title
  const { title } = FilterMenus[domain].subs.find(sub => sub.key === type)
  return (
    <>
      {title.startsWith(domainName) ? title : `${domainName} ${title}`}{' '}
      <em className="fw_bold">
        {tooltip ? (
          <Tooltip
            content={<FilterText domain={domain} type={type} data={data} />}
            position="bottom"
            offsetY={5}
            display="inline"
            nowrap={false}>
            <FilterText domain={domain} type={type} data={data} />
          </Tooltip>
        ) : (
          <FilterText domain={domain} type={type} data={data} />
        )}
      </em>
    </>
  )
}
FilterName.propTypes = {
  domain: PropTypes.string,
  type: PropTypes.string,
  data: PropTypes.object,
  tooltip: PropTypes.bool,
}

export default FilterName
